<template>
    <!-- 用户中奖信息 -->
    <div id="award_info">
        <div class="message_container">
            <div class="icon">
                <img
                    src="../img/award-report.png"
                    alt="png">
            </div>
            <div class="roll-message">
                <!-- 通过v-if保证swiper在数据加载完成后加载 -->
                <swiper
                    v-if="award_list.length>0"
                    ref="mySwiper"
                    :options="swiperOption"
                    class="swiper_wrap swiper-no-swiping"
                >
                    <swiper-slide
                        v-for="(item,index) in award_list"
                        :key="index"
                        class="swiper_slide message_slide_item"
                    >
                        <div class="award_info">
                            <span>大大哥{{ index }} 获得: 大哥大</span>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
    components: { swiper, swiperSlide },
    props:{
        lottery_record_list: {
            type: Array,
            default: function(){
                return [1,2,3,4,5,6,7,8];
            }
        }
    },
    data: () => {
        return {
            award_list: [],
            swiperOption: {
                direction: "vertical",
                autoplay: {
                    delay: 2500,
                },
                loop: true,
            },
        };
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper && this.$refs.mySwiper.swiper;
        },
    },
    watch: {
        lottery_record_list: {
            handler(newVal){
                this.award_list = newVal;
            },
            deep: true
        }
    },
    mounted: function () {
        this.award_list = this.lottery_record_list;
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';
#award_info {
    width: vws(562px);
    height: vws(48px);
    border-radius: vws(23px);
    margin: vws(4px) auto vws(20px);
    background: #A57F5D;
}

.message_container {
    width: vws(497px);
    height: vws(46px);
    border-radius: vws(23px);
    position: relative;
    display: flex;
    align-items: center;
    padding-left: vws(20px);
    .icon {
        width: vws(21px);
        height: vws(21px);
        display: flex;
        align-items: center;
        img {
            width: 100%;
            height: 100%;
        }
    }
}

.roll-message {
    width: vws(470px);
    height: vws(46px);
    color: #FF4571;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: vws(12px);
}

.swiper_wrap {
    width: vws(470px) !important;
    height: vws(46px) !important;
    z-index: 0;
}

.swiper_slide{
    position: relative;
}

.award_info {
    width: vws(470px);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    font-size: vws(26px);
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    height: vws(46px);
    line-height: vws(46px);
    position: relative;
    top: vws(2px);
}
</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/AwardInfo.vue